module.exports = function getSingleLayoutSizes(
	hasSidebar,
	hasTags,
	sidebarSize
) {
	let sizes = [12, 0];
	let _has_sidebar = hasSidebar || hasTags;
	if (_has_sidebar) {
		switch (sidebarSize) {
			case "large":
				sizes = [7, 5];
				break;
			case "medium":
				sizes = [8, 4];
				break;
			default:
				sizes = [9, 3];
				break;
		}
	}
	return sizes;
};
